import Page from '../../components/Page';
import { observer } from 'mobx-react-lite';
import { Route } from 'react-router-dom';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import NewParkingPass from './NewParkingPass';
import ParkingPass from './ParkingPass';
import ParkingPassesOverview from './ParkingPassesOverview';
import ImportCsv from './ImportCsv';
import ImportPasses from './ImportPasses';

const ParkingPassesTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.PARKING_PASSES}>
                <ParkingPassesOverview store={store} />
            </Route>
            <Route exact path={Paths.NEW_PARKING_PASS}>
                <NewParkingPass store={store} />
            </Route>
            <Route exact path={Paths.PARKING_PASS}>
                <ParkingPass store={store} />
            </Route>
            <Route exact path={Paths.PARKING_IMPORT_CSV}>
                <ImportCsv store={store} />
            </Route>
            <Route exact path={Paths.PARKING_IMPORT_PASSES}>
                <ImportPasses store={store} />
            </Route>
        </Page>
    );
};

export default observer(ParkingPassesTab);
